import { render, staticRenderFns } from "./angsuranlist.vue?vue&type=template&id=db34c25e&"
import script from "./angsuranlist.vue?vue&type=script&lang=js&"
export * from "./angsuranlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports